import { render, staticRenderFns } from "./FormReasonsNotShipped.vue?vue&type=template&id=b815369e&scoped=true&name=form-reasons&"
import script from "./FormReasonsNotShipped.vue?vue&type=script&lang=js&"
export * from "./FormReasonsNotShipped.vue?vue&type=script&lang=js&"
import style0 from "./FormReasonsNotShipped.vue?vue&type=style&index=0&id=b815369e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b815369e",
  null
  
)

/* custom blocks */
import block0 from "./FormReasonsNotShipped.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports